// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__b8V8-","terms":"Footer_terms__P+V18","rights":"Footer_rights__oa3wa"};